// CSS Pseudo-classes reference
// Based on https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes

export const PSEUDO_CLASSES = [
    { value: 'normal', label: 'Normal', prefix: '', hasArgs: false, description: 'Default state' },

    // Interactive states
    { value: 'hover', label: 'Hover', prefix: 'hover:', hasArgs: false, description: 'Mouse over element' },
    { value: 'active', label: 'Active', prefix: 'active:', hasArgs: false, description: 'Element is being activated' },
    { value: 'focus', label: 'Focus', prefix: 'focus:', hasArgs: false, description: 'Element has focus' },
    { value: 'focus-within', label: 'Focus Within', prefix: 'focus-within:', hasArgs: false, description: 'Element or descendant has focus' },
    { value: 'focus-visible', label: 'Focus Visible', prefix: 'focus-visible:', hasArgs: false, description: 'Element has focus via keyboard' },
    { value: 'visited', label: 'Visited', prefix: 'visited:', hasArgs: false, description: 'Visited link' },

    // Form states
    { value: 'disabled', label: 'Disabled', prefix: 'disabled:', hasArgs: false, description: 'Disabled element' },
    { value: 'enabled', label: 'Enabled', prefix: 'enabled:', hasArgs: false, description: 'Enabled element' },
    { value: 'checked', label: 'Checked', prefix: 'checked:', hasArgs: false, description: 'Checked input' },
    { value: 'indeterminate', label: 'Indeterminate', prefix: 'indeterminate:', hasArgs: false, description: 'Indeterminate state' },
    { value: 'default', label: 'Default', prefix: 'default:', hasArgs: false, description: 'Default element in group' },
    { value: 'required', label: 'Required', prefix: 'required:', hasArgs: false, description: 'Required input' },
    { value: 'optional', label: 'Optional', prefix: 'optional:', hasArgs: false, description: 'Optional input' },
    { value: 'valid', label: 'Valid', prefix: 'valid:', hasArgs: false, description: 'Valid form control' },
    { value: 'invalid', label: 'Invalid', prefix: 'invalid:', hasArgs: false, description: 'Invalid form control' },
    { value: 'in-range', label: 'In Range', prefix: 'in-range:', hasArgs: false, description: 'Value in range' },
    { value: 'out-of-range', label: 'Out of Range', prefix: 'out-of-range:', hasArgs: false, description: 'Value out of range' },
    { value: 'placeholder-shown', label: 'Placeholder Shown', prefix: 'placeholder-shown:', hasArgs: false, description: 'Placeholder is shown' },
    { value: 'read-only', label: 'Read Only', prefix: 'read-only:', hasArgs: false, description: 'Read-only element' },
    { value: 'read-write', label: 'Read Write', prefix: 'read-write:', hasArgs: false, description: 'Editable element' },

    // Structural pseudo-classes
    { value: 'first-child', label: 'First Child', prefix: 'first:', hasArgs: false, description: 'First child element' },
    { value: 'last-child', label: 'Last Child', prefix: 'last:', hasArgs: false, description: 'Last child element' },
    { value: 'only-child', label: 'Only Child', prefix: 'only:', hasArgs: false, description: 'Only child element' },
    { value: 'first-of-type', label: 'First of Type', prefix: 'first-of-type:', hasArgs: false, description: 'First of its type' },
    { value: 'last-of-type', label: 'Last of Type', prefix: 'last-of-type:', hasArgs: false, description: 'Last of its type' },
    { value: 'only-of-type', label: 'Only of Type', prefix: 'only-of-type:', hasArgs: false, description: 'Only of its type' },
    { value: 'empty', label: 'Empty', prefix: 'empty:', hasArgs: false, description: 'Element with no children' },

    // Structural pseudo-classes with arguments (note: Tailwind doesn't support these directly via prefixes)
    // These would need custom arbitrary variants like [&:nth-child(2)]:
    // { value: 'nth-child', label: 'Nth Child', prefix: '', hasArgs: true, argPlaceholder: 'e.g. 2, odd, 2n+1', description: 'Matches based on position' },
    // { value: 'nth-of-type', label: 'Nth of Type', prefix: '', hasArgs: true, argPlaceholder: 'e.g. 2, odd, 2n+1', description: 'Matches based on type position' },
    // { value: 'nth-last-child', label: 'Nth Last Child', prefix: '', hasArgs: true, argPlaceholder: 'e.g. 2, odd, 2n+1', description: 'Matches from end' },
    // { value: 'nth-last-of-type', label: 'Nth Last of Type', prefix: '', hasArgs: true, argPlaceholder: 'e.g. 2, odd, 2n+1', description: 'Matches type from end' },

    // Others
    { value: 'target', label: 'Target', prefix: 'target:', hasArgs: false, description: 'Target of URL fragment' },
    { value: 'open', label: 'Open', prefix: 'open:', hasArgs: false, description: 'Open details/dialog' },
];

// Tailwind-specific responsive and other modifiers
export const TAILWIND_MODIFIERS = [
    // Dark mode
    { value: 'dark', label: 'Dark Mode', prefix: 'dark:', hasArgs: false, description: 'Dark mode variant' },

    // Group states
    { value: 'group-hover', label: 'Group Hover', prefix: 'group-hover:', hasArgs: false, description: 'Parent group is hovered' },
    { value: 'group-focus', label: 'Group Focus', prefix: 'group-focus:', hasArgs: false, description: 'Parent group has focus' },

    // Peer states
    { value: 'peer-checked', label: 'Peer Checked', prefix: 'peer-checked:', hasArgs: false, description: 'Peer is checked' },
    { value: 'peer-focus', label: 'Peer Focus', prefix: 'peer-focus:', hasArgs: false, description: 'Peer has focus' },
    { value: 'peer-hover', label: 'Peer Hover', prefix: 'peer-hover:', hasArgs: false, description: 'Peer is hovered' },
];

export const ALL_STATES = [...PSEUDO_CLASSES, ...TAILWIND_MODIFIERS];

export const getStateByValue = (value) => {
    return ALL_STATES.find(s => s.value === value);
};

export const getStatePrefix = (value) => {
    const state = getStateByValue(value);
    return state ? state.prefix : '';
};
